module.exports = __webpack_public_path__ + "img/integrations-key-features.8927a7bb.png";